<section class="siteIntegration__authorizeConnectionWrapper">
  <section class="siteIntegration__authorizeConnection">
    <header class="siteIntegration__authorizeConnectionHeader">
      {{ headerText }}
    </header>

    @if (subheaderText) {
      <header class="siteIntegration__authorizeConnectionSubheader">
        {{ subheaderText }}
      </header>
    }

    <pp-authorization-progress [ppStep]="ppIntegrationStep"></pp-authorization-progress>

    @if (ppIntegrationStep === EAuthorizationProgressStep.PENDING) {
      <div
        class="siteIntegration__authorizeConnectionTimeout"
        >
        @if (!timeExpired) {
          <span>
            {{
            'authorize_connection_timeout'
            | ppTranslate
            : {
            time: remainingTime,
          }
          }}
        </span>
      }
      @if (timeExpired) {
        <span>{{ 'integration_authentication_time_out' | ppTranslate }}</span>
      }
    </div>
  }

  <pp-site-settings-integrations-tooltips
    [ppIntegrationStep]="ppIntegrationStep"
    (ppCancel)="cancelConnection()"
    (ppDeactivate)="showDeactivateConnectionModal()"
    [ppDisabled]="ppDisabled"
    [ppSiteName]="siteName"
    [ppAssetName]="assetName"
  ></pp-site-settings-integrations-tooltips>
</section>

@if (ppIntegrationStep === EAuthorizationProgressStep.INITIAL) {
  <pp-button
    (ppAction)="showAuthorizeConnectionModal()"
    ppStyle="primary"
    ppSize="large"
    [ppDisabled]="ppDisabled"
    >{{ 'authorize_connection' | ppTranslate }}</pp-button
    >
  }
</section>
